/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { StringBuilder } from "igniteui-react-core";
import { stringIsNullOrEmpty, stringEndsWith } from "igniteui-react-core";
import { isNaN_ } from "igniteui-react-core";
/**
 * @hidden
 */
var CellModelExport = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CellModelExport, _super);
    function CellModelExport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.r = 0;
        _this.s = 0;
        _this.n = 0;
        _this.o = 0;
        _this.k = 0;
        _this.q = 0;
        _this.m = 0;
        _this.h = 0;
        _this.l = 0;
        _this.i = 0;
        _this.a = null;
        _this.b = null;
        _this.d = 0;
        _this.e = 0;
        _this.aa = null;
        _this.c = null;
        _this.w = null;
        _this.x = null;
        _this.y = null;
        _this.j = 0;
        _this.u = null;
        _this.v = null;
        _this.p = 0;
        _this.f = 0;
        _this.t = 0;
        _this.g = false;
        _this.z = null;
        return _this;
    }
    CellModelExport.prototype.ab = function () {
        var a = new StringBuilder(0);
        a.l("{ ");
        a.l("type : \"" + this.ac + "\", ");
        a.l("x : " + this.r + ", ");
        a.l("y : " + this.s + ", ");
        a.l("snappedX : " + this.n + ", ");
        a.l("snappedY : " + this.o + ", ");
        a.l("height : " + this.k + ", ");
        a.l("width : " + this.q + ", ");
        a.l("lineBreakMode: \"" + this.z + "\", ");
        a.l("selectedStatus : " + this.m + ", ");
        a.l("activationStatus : " + this.h + ", ");
        a.l("virtualizationPercentage : " + this.p + ", ");
        a.l("backgroundBrushData : " + this.a.serialize() + ", ");
        if (this.b != null) {
            a.l("borderBrushData : " + this.b.serialize() + ", ");
        }
        a.l("opacity : " + this.l + ", ");
        a.l("contentOpacity : " + this.i + ", ");
        if (this.d != null) {
            a.l("horizontalAlignment : " + this.d + ", ");
        }
        if (this.e != null) {
            a.l("verticalAlignment : " + this.e + ", ");
        }
        a.l("renderValue : \"" + this.aa + "\", ");
        if (this.c != null) {
            a.l("textColor : " + this.c.serialize() + ", ");
        }
        if (!stringIsNullOrEmpty(this.w)) {
            a.l("fontStyle : \"" + this.w + "\", ");
        }
        if (!stringIsNullOrEmpty(this.x)) {
            a.l("fontVariant : \"" + this.x + "\", ");
        }
        if (!stringIsNullOrEmpty(this.y)) {
            a.l("fontWeight : \"" + this.y + "\", ");
        }
        if (!stringIsNullOrEmpty(this.u)) {
            a.l("fontFamily : \"" + this.u + "\", ");
        }
        if (!stringIsNullOrEmpty(this.v)) {
            a.l("fontStretch : \"" + this.v + "\", ");
        }
        if (!isNaN_(this.j)) {
            a.l("fontSize : " + this.j + ", ");
        }
        a.l("sortDirection : " + this.f + ", ");
        a.l("indent : " + this.t + ", ");
        a.l("isCollapsable : " + this.g.toString().toLowerCase() + ", ");
        this.ad(a);
        var b = a.toString();
        if (stringEndsWith(b, ", ")) {
            b = b.substr(0, b.length - 2);
        }
        b += "} ";
        return b;
    };
    CellModelExport.prototype.get_ac = function () {
        return "Cell";
    };
    Object.defineProperty(CellModelExport.prototype, "ac", {
        get: function () {
            return this.get_ac();
        },
        enumerable: true,
        configurable: true
    });
    CellModelExport.prototype.ad = function (a) {
    };
    CellModelExport.$t = markType(CellModelExport, 'CellModelExport');
    return CellModelExport;
}(Base));
export { CellModelExport };
//# sourceMappingURL=CellModelExport.js.map
